module.exports = __webpack_public_path__ + "img/slika57.9feabc71.jpg";